import React, { useRef, useState, useEffect } from 'react';
import { changeFirstLoginPassword } from '../../../api/auth/authApi';
import { toast } from 'react-toastify';
import './ModalPrimeiroAcesso.css';

interface ModalPrimeiroAcessoProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const ModalPrimeiroAcesso: React.FC<ModalPrimeiroAcessoProps> = ({ isOpen, onClose, onSuccess }) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleSubmit = async () => {
    if (!newPassword || !confirmNewPassword) {
      toast.error('Preencha todos os campos');
      return;
    }

    if (newPassword !== confirmNewPassword) {
      toast.error('As senhas não coincidem');
      return;
    }

    try {
      setLoading(true);
      const result = await changeFirstLoginPassword({ newPassword, confirmNewPassword });
      toast.success(result.message || 'Senha alterada com sucesso!');
      onSuccess();
    } catch (err: any) {
      toast.error(err.response?.data?.message || 'Erro ao alterar senha');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        <div className="form-titulo-car">Alterar senha no primeiro acesso</div>
        <div className="form-item-titulo mt-20">Sua nova senha deve ter no mínimo 8 caracteres, incluindo uma letra, um número e um caractere especial</div>
        <div className="form-item mt-20">Digite a nova senha</div>
        <input
          type="password"
          className="form-input mt-20 form-style"
          placeholder="Nova senha"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <div className="form-item mt-20">Confirme a nova senha</div>
        <input
          type="password"
          className="form-input form-style"
          placeholder="Confirmar nova senha"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
        />

        <div className='alignCenter'>
          <div className="form-buttons mt-20">
            <button
              type="button"
              className="form-button-modal-primeiro-acesso"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPrimeiroAcesso;
